import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import WebContainer from "./component/WebContainer/Index";
import Contact from './component/Contact/Index'
import { Download } from "@mui/icons-material";

const Error = () => {
  const location = useLocation();
  const isThankYouPage = location.pathname === "/thank-you";

  // Retrieve fileURL from query parameters and extract the file name.
  const searchParams = new URLSearchParams(location.search);
  const fileURL = searchParams.get("fileURL");
  const fileName = fileURL ? fileURL.substring(fileURL.lastIndexOf("/") + 1) : "";

  return (
    <>
    <WebContainer _parentClass={"col-12 float-start m-0 error"}>
      {isThankYouPage ? (
        <div className="col-lg-8 col-12 m-auto text-center">
          <h2 className="mt-0">Thank you for your interest!</h2>
          <p>
            A representative from Home & Soul will get in touch with you shortly.
          </p>
          {fileName && (
             <>
             <br/>
             <p><strong>Your download is ready.</strong></p>
            <a href={fileURL} target="_blank" rel="noopener noreferrer" className="mt-5 buttons">
            <span>Download Now <Download /></span>
          </a>
             </>
          )}
        </div>
      ) : (
        <div className="col-lg-8 col-12 m-auto text-center">
          <h1 className="mt-0">404</h1>
          <h2>WE ARE SORRY, PAGE NOT FOUND!</h2>
          <p>
            THE PAGE YOU ARE LOOKING FOR MIGHT HAVE BEEN REMOVED, HAD ITS NAME
            CHANGED, OR IS TEMPORARILY UNAVAILABLE.
          </p>
          <NavLink to="/" className="btn-11 buttons">
            <span>Back to homepage</span>
          </NavLink>
        </div>
      )}
    </WebContainer>
    <div className="section proDetail paddingRemove ">
    <Contact />
    </div>
    </>
  );
};

export default Error;
